import * as React from 'react';

import { AssetTab } from '@blockworks/platform/api/strapi';
import { RenderMarkdown, RenderContent } from '@blockworks/ui/legacy/html';

import PriceSectionHeader from '@/components/pages/price/components/header/price-section-header';

type PriceAboutSummaryProps = {
    title: string;
    description: string;
    summary: AssetTab | null;
};

const PriceAboutSummary = (props: PriceAboutSummaryProps) => {
    const { title, description, summary } = props;

    if (!summary && !description) {
        return null;
    }

    return (
        <>
            <PriceSectionHeader title={`about ${title}`} />
            <section className="py-8">
                <h3 className="truncate text-xl font-headline px-8 leading-9">What is {title}?</h3>
                <div className="px-8 mt-2">
                    {summary ? (
                        <RenderMarkdown text={summary?.content ?? ''} className="leading-loose" fullWidth />
                    ) : (
                        <RenderContent html={description} className="leading-loose" fullWidth />
                    )}
                </div>
            </section>
        </>
    );
};

export default PriceAboutSummary;
